

































import { computed, defineComponent, ref, watch, watchEffect } from '@vue/composition-api';

export default defineComponent({
  emits: ['input'],

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  setup: function (props, { emit }) {
    const menu = ref(false);
    const dateModel = ref<string[]>([]);

    const unwatch = watchEffect(function () {
      dateModel.value = [...props.value as string[]];
    });
    unwatch();

    watch(() => dateModel.value, function (value: string[]) {
      emit('input', value);
    });


    const dateLabel = computed(() => props.value.join(' - '));
    function inputHandler () {
      if (dateModel.value.length === 2) {
        menu.value = false;
      }
    }

    return {
      menu,
      dateModel,
      dateLabel,
      inputHandler,
    };
  },
});
